// src/api/apiClient.ts
import axios from "axios";
import { Project  } from "../types/project";

export interface UserCompany {
  companyNo: number;
    companyName: string;
  userType: string | null;
}

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "https://localhost:7243/api",
   withCredentials: true,
});
/* const API = axios.create({
  baseURL: "https://baevr-chat-gtcma6bkhshtbved.centralindia-01.azurewebsites.net/api",
}); */
// ✅ Request interceptor
/* API.interceptors.request.use((req) => {
  const token = localStorage.getItem("token");

  if (token) {
    req.headers = req.headers || {};
    req.headers.Authorization = `Bearer ${token}`;
  }

  return req;
}); */
API.interceptors.request.use((req) => {
  const token = localStorage.getItem("authToken");

  if (token) {
    req.headers.Authorization = `Bearer ${token}`;
  }

  return req;
});
// ✅ Response interceptor
API.interceptors.response.use(
  (res) => res,   
  (err) => {
    if (err.response?.status === 401) {
      //localStorage.removeItem("token");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);


// ============================
// 🔐 AUTH API
// ============================
export const AuthAPI = {

  login: (email: string, password: string) =>
    API.post("/Auth/login", {
      email,
      password,
    }),

  me: () =>
    API.get("/Auth/me"),

  register: (data: any) =>
    API.post("/auth/register", data),

  forgotPassword: (email: string) =>
    API.post("/auth/forgot-password", {
      email,
    }),

  resetPassword: (
    token: string,
    newPassword: string
  ) =>
    API.post("/auth/reset-password", {
      token,
      newPassword,
    }),

  trialLogin: (mobileNo: string) =>
    API.post("/auth/trial-login", {
      mobileNo,
    }),
};

export const CompanySelection = {

  setSelectedCompany: (companyNo: number) => {
    localStorage.setItem(
      "selectedCompanyNo",
      companyNo.toString()
    );
  },

  getSelectedCompany: (): number | null => {
    const value =
      localStorage.getItem("selectedCompanyNo");

    if (!value) {
      return null;
    }

    const companyNo = Number(value);

    return Number.isNaN(companyNo)
      ? null
      : companyNo;
  },

  clearSelectedCompany: () => {
    localStorage.removeItem(
      "selectedCompanyNo"
    );
  },
};

// ============================
// 📁 PROJECT API
// ============================
export const ProjectAPI = {
  //getAll: () => API.get("Projects"),
  getAll: async (): Promise<Project[]> => {
  const res = await API.get("/Projects");
  return res.data; // ✅ ALWAYS ARRAY
},

 // create: (data: any) => API.post("/projects", data),
   /* create: async (data: any) => {
    const res = await API.post("/CreateProject", data); // 🔥 FIXED
    return res.data;
  }, */
  create: async (data: FormData) => {
  const res = await API.post("/CreateProject", data);
  return res.data;
},

  /*update: (id: number, data: any) =>
    API.put(`/projects/${id}`, data),

  delete: (id: number) =>
    API.delete(`/projects/${id}`),*/
   // ✅ ADD THIS
 /*  getUsers: async (projectNo: number) => {
    const res = await API.get(`/CompanyAdmin/project-users/${projectNo}`);
    return res.data;
  }, */
  getUsers: async (projectNo: number) => {
  const res = await API.get(`/projects/${projectNo}/users`);
  return res.data;
},

 

    getById: async (id: string | number): Promise<Project> => {
  const res = await API.get(`/CreateProject/${id}`);
  return res.data;
},

     update: async (id: number, data: FormData) => {
    const res = await API.put(`/CreateProject/${id}`, data);
    return res.data;
  },
};

export const BlobAPI = {
  /* upload: async (data: FormData) => {
    const res = await API.post("/blobfiles/upload", data);
    return res.data;
  }, */
  uploadFileOnly: async (
  file: File,
  params: {
    containerName: string;
    entityType: string;
    entityNo: number;
    project: number;
    sno: number;
  }
) => {
  const formData = new FormData();
  formData.append("file", file);

  const res = await API.post("/blobfiles/upload", formData, {
    params,
  });

  return res.data;
},

    get: async (entityType: string, entityNo: number) => {
    const res = await API.get("/blobfiles/get", {
      params: { entityType, entityNo },
    });
    return res.data;
  },
   getImage: async (entityType: string, entityNo: number) => {
    const res = await API.get("/blobfiles/image", {
      params: { entityType, entityNo },
      responseType: "blob",
    });

    return URL.createObjectURL(res.data);
  },
  delete: async (
  entityType: string,
  entityNo: number,
  containerName: string
) => {
  const res = await API.delete("/blobfiles/delete", {
    params: {
      entityType,
      entityNo,
      containerName,
    },
  });

  return res.data;
},
};

// ============================
// 🏢 COMPANY API
// ============================
// ============================
// 🏢 COMPANY API
// ============================
export const CompanyAPI = {

  // ============================================================
  // NEW USER + NEW COMPANY
  // ============================================================
  registerCompany: (data: {
    clientName: string;
    description?: string;
    contactPerson?: string;
    username: string;
    email: string;
    password: string;
    phoneNo?: string;
    companyWebsite?: string;
  }) =>
    API.post("/RegisterCompany", data),


  // ============================================================
  // EXISTING USER + NEW COMPANY
  // ============================================================
  registerExistingUserCompany: (data: {
    clientName: string;
    description?: string;
    contactPerson?: string;
    companyWebsite?: string;
  }) =>
    API.post(
      "/RegisterCompany/register-existing-user-company",
      data
    ),


  // ============================================================
  // COMPANY USERS
  // ============================================================

  getUsers: (companyNo: number) =>
    API.get("/CompanyAdmin/company-users", {
      params: {
        companyNo,
      },
    }),


  // ============================================================
  // ADD USER TO COMPANY
  // ============================================================

  addUser: (data: {
    companyNo: number;
    email: string;
    role: string;
  }) =>
    API.post(
      "/CompanyAdmin/add-user",
      data
    ),


  // ============================================================
  // REMOVE USER FROM COMPANY
  // ============================================================

  removeUser: (data: {
    companyNo: number;
    email: string;
  }) =>
    API.post(
      "/CompanyAdmin/remove-user",
      data
    ),


  // ============================================================
  // AVAILABLE USERS
  // ============================================================

  getAvailableUsers: (companyNo: number) =>
    API.get(
      "/CompanyAdmin/available-users",
      {
        params: {
          companyNo,
        },
      }
    ),


  // ============================================================
  // GET USER ROLE
  // ============================================================

  getUserRole: (
    email: string,
    companyNo: number
  ) =>
    API.get(
      "/CompanyAdmin/user-role",
      {
        params: {
          email,
          companyNo,
        },
      }
    ),


  // ============================================================
  // UPDATE USER ROLE
  // ============================================================

  updateUserRole: (data: {
    companyNo: number;
    email: string;
    role: string;
  }) =>
    API.put(
      "/CompanyAdmin/update-user-role",
      data
    ),


  // ============================================================
  // PROJECT USER ASSIGNMENT
  // ============================================================

  assignUserToProject: (data: {
    projectNo: number;
    email: string;
  }) =>
    API.post(
      "/CompanyAdmin/assign-user-to-project",
      data
    ),


  removeUserFromProject: (data: {
    projectNo: number;
    email: string;
  }) =>
    API.post(
      "/CompanyAdmin/remove-user-from-project",
      data
    ),


  // ============================================================
  // COMPANY PROJECTS
  // ============================================================

  getCompanyProjects: (companyNo: number) =>
    API.get(
      "/CompanyAdmin/company-projects",
      {
        params: {
          companyNo,
        },
      }
    ),
};
// ============================
// 🌳 WORKTREE API
// ============================
export const WorkTreeAPI = {
  getByProject: async (projectId: string | number) => {
    const res = await API.get(`/WorkTree/${projectId}`);
    return res.data; // ✅ returns array
  },
};
// ============================
// 🌳 TREE API (NEW)
// ============================
export const TreeAPI = {
  getTree: async (projectId: number | string) => {
    const res = await API.get(`/tree/${projectId}`);
    return res.data;
  },
};
/*export const ParameterAPI = {
  getBySet: async (tbv: number) => {
    const res = await API.get(`/parameters/${tbv}`);
    return res.data;
  },
};*/
export const ParameterAPI = {
  /*getBySet: async (tbv: number) => {
    const res = await API.get(`/parameters/${tbv}`);
    return res.data;
  },*/
  
  //correct
  /*getBySet: async (tbv: number, sessionNo: number) => {
  const res = await API.get(`/parameters/${tbv}/${sessionNo}`);
  return res.data;
},*/
getBySet: async (tbv: number, projectId: number, sessionNo: number) => {
  const res = await API.get(`/parameters/${tbv}/${projectId}/${sessionNo}`);
  return res.data;
},


  update: async (data: {
    parameterNo: number;
    parameterName: string;
    value: number;
  }) => {
    const res = await API.put("/parameters/update", data);
    return res.data;
  },
};
// ============================
// 📋 NODE COPY API
// ============================
export const NodeCopyAPI = {
  copy: async (wbs: number, sno: number ) => {
    const res = await API.post("/wbscopy", {
      wbs,
      sno,
    });
    return res.data;
  },
};


// ============================
// 🗑️ NODE DELETE API
// ============================
export const NodeDeleteAPI = {
  remove: async (wbs: number, sno: number ) => {
    const res = await API.post("/wbsdelete", {
      wbs,
      sno,
    });
    return res.data;
  },
};


// ============================
// 🔁 SET COPY API (NOTATION DUPLICATE)
// ============================
export const SetCopyAPI = {
  duplicate: async (
    setno: number,
    project: number,
    sno: number 
  ) => {
    const res = await API.post("/setcopy", {
      setno,
      sno,
      project,
    });

    return res.data;
  },
};
// ============================
// ❌ SET DELETE API (NOTATION DELETE)
// ============================
export const SetDeleteAPI = {
  remove: async (setno: number, sno: number) => {
    const res = await API.post("/setdelete", {
      setno,
      sno,
    });

    return res.data;
  },
};

export const SessionAPI = {
 // create: async (projectNo: number, userNo: number) => {
  create: async (projectNo: number, userNo?: number | null) => {
    const res = await API.post("/session/create", {
      projectNo,
     userNo
    });

    return res.data;
  },
};
/*export const SessionAPI = {
  create: async (projectNo: number, username: string) => {
    const res = await API.post("/session/create", {
      projectNo,
      username,
    });

    return res.data;
  },
};*/
export const MeasureAPI = {
  update: async (data: {
    wmno: number;
    sno: number;
    mval: number;
    axn: string;
  }) => {
    const res = await API.post("/measure", data);
    return res.data;
  },
};
// ============================
// 📊 BOQ API
// ============================
/*export const BoqAPI = {
  // 🔥 Tree structure (main)
  getTree: async (wbs: number) => {
    const res = await API.get(`/boq/tree/${wbs}`);
    return res.data;
  },

  // 🔹 Flat data (optional)
  getFlat: async (wbs: number) => {
    const res = await API.get(`/boq/flat/${wbs}`);
    return res.data;
  },
};*/
// ============================
// 📊 BOQ API
// ============================

/* export const BOQAPI = {
  getByWBS: async (wbs: number) => {
    const res = await API.get(`/BOQModule/${wbs}`); // ✅ FIXED
    return res.data;
  },
};
 */

export const BOQAPI = {
  getByWBS: async (wbs: number) => {
    const res = await API.get(`/BOQModule/${wbs}`);

    const result = res.data;

    return Array.isArray(result)
      ? result
      : result?.data ?? [];
  },
};


export const BOMAPI = {
  getByWBS: async (wbs: number) => {
    const res = await API.get(`/boqreportmodule/${wbs}`); // ✅ EXACT MATCH
    return res.data;
  },
};
// ============================
// 🛠️ SQL GENERIC API (ADD THIS)
// ============================
/*export const SqlAPI = {
  update: async (table: string, key: string, data: any) => {
    const res = await API.post("/sql/update", {
      table,
      key,
      data,
    });
    return res.data;
  },
};*/
export const SqlAPI = {
  update: async (table: string, key: string, data: any) => {
    const res = await API.post("/sql/update", {
      Table: table,   // ✅ FIX
      Key: key,       // ✅ FIX
      Data: data,     // ✅ FIX
    });
    return res.data;
  },
 
  // ✅ ADD THIS
  
/*select: async (table: string, filters: any) => {
    const res = await API.post("/sql/select", {
      table,
      filters,
    });

    return res.data;
  },*/

  select: async (table: string, filters: any) => {
  const res = await API.post("/sql/select", {
    Table: table,
    Filters: filters,
  });

  return res.data;
},
  
 /* getNotationsByProjectAndParent: async (project: number, parentNotation: number) => {
    const res = await API.post("/sql/select", {
      Table: "Notations",
      Filters: {
        Project: project,
        ParentNotation: parentNotation,
      },
    });
    return res.data;
  },*/
  
   
};
// ============================
// ⚙️ IMPORT WIZ API (NEW)
// ============================
export const ImportWizAPI = {
  get: async (tbv: number) => {
    const res = await API.get(`/importwiz/${tbv}`);
    return res.data;
  },

  // ✅ ADD THIS
  addToProject: async (data: {
    tagNo: number;
    parentNode: number;   // 🔥 ADD THIS
    project: number;
    session: number;
    name: string;
  }) => {
    const res = await API.post(`/importwiz/add`, data);
    return res.data;
  },

  addSetImport: async (payload: any) => {
  const res = await API.post("/setimport", payload);
  return res.data;
},
   // 🔥 ADD THIS NEW METHOD
  /*getWorkGroups: async (setno: number) => {
    const res = await API.get(`/importwiz/workgroups/${setno}`);
    return res.data;
  },*/
getWorkGroups: async (setno: number) => {
  const res = await API.post(`/sql/execsp`, {
    sp: "WGForSetImport",
    params: { setno },
  });
  return res.data;
},
// inside ImportWizAPI
addSubSetImport: async (payload: {
   mark: number;
   sno: number;
   MarkIds: { MarkId: number }[];
 }) => {
   const res = await API.post("/SubSetImport", payload);
   return res.data;
 },
 /* getSubWorkGroups: async (setno: number) => {
  const res = await API.get(`/importwiz/subworkgroups/${setno}`);
  return res.data;
},*/
  // NEW: Link Import
  linkImport: async (
    mark: number,
    sno: number,
    link: number
  ) => {
    const res = await API.post("/LinkImport", {
      mark,
      sno,
      link
    });

    return res.data;
  },
getAlreadyLinkedParts: async (mark: number) => {
    const res = await API.get(`/importwiz/already-linked-parts/${mark}`);
    return res.data;
  },
};

// ============================
// 🌳 SECOND WBS API
// ============================
export const SecondWBSAPI = {
  getTree: async (projectId: number | string) => {
    const res = await API.get(`/wbs/${projectId}`);
    return res.data;
  },


  /* getNotationParameterMatrix: async (wbsId: number) => {
  const res = await API.get(`/NotationParameterMatrix?wbsId=${wbsId}`);
  return res.data;
}, */
};
// ============================
// 🌳 THIRD WORKTREE API
// ============================
export const ThirdWorkTreeAPI = {
  getWorkTree: async (wbsId: number) => {
    const res = await API.get(`/ThirdWorkTree/${wbsId}`);
    return res.data;
  },

  getWorks: async (workGroupNo: number) => {
  const res = await API.get(
    `/ThirdWorkTree/works/${workGroupNo}`
  );
  return res.data;
},
 getTakeOffs: async (workNo: number) => {
    const res = await API.get(
      `/ThirdWorkTree/takeoff/${workNo}`
    );
    return res.data;
  },
  getWorkMeasures: async (workNo: number) => {
  const res = await API.get(
    `/ThirdWorkTree/workmeasures/${workNo}`
  );
  return res.data;
},
  getWorkGroupsByNotation: async (notationNo: number) => {
    const res = await API.get(
      `/ThirdWorkTree/notation/${notationNo}`
    );
    return res.data;
  },

  getWorkDetails: async (workNo: number) => {
  const res = await API.get(
    `/ThirdWorkTree/workdetails/${workNo}`
  );
  return res.data;

},
getWorksByNotation: async (
  workGroupNo: number,
  notationNo: number
) => {
  const res = await API.get(
    `/ThirdWorkTree/works/${workGroupNo}/notation/${notationNo}`
  );

  return res.data;
},
getWorkGroupDetails: async (workGroupNo: number) => {
  const res = await API.get(
    `/ThirdWorkTree/workgroupdetails/${workGroupNo}`
  );

  return res.data;
},

};
/* export const ThirdWBSAPI = {
  getTree: async (projectId: number | string) => {
    const res = await API.get(`/thirdwbs/${projectId}`);
    return res.data;
  },
   
  getActivities: async (
  projectId: number | string,
  wbs: number,
  lvl: number = 0
) => {
  const res = await API.get(
    `/thirdwbs/activity/${projectId}/${wbs}/${lvl}`
  );

  return res.data;
}, */
export const ThirdWBSAPI = {
  getTree: async (projectId: number | string, lvl: number = 0) => {
    const res = await API.get(`/thirdwbs/${projectId}/${lvl}`);
    return res.data;
  },

  getActivities: async (
    projectId: number | string,
    wbs: number,
    lvl: number = 0
  ) => {
    const res = await API.get(`/thirdwbs/activity/${projectId}/${wbs}/${lvl}`);
    return res.data;
  },

  getTakeoffAccordionMatrix: async (
  activityId: number,
  wbsId: number
) => {
  const res = await API.post(`/takeoff/accordion-matrix`, {
    activityId,
    wbsId,
  });

  return res.data;
},
 getTakeoffAccordionMetrix: async (activityId: number, wbsId: number) => {
    const res = await API.get(`/Metrix/metrics`, {
      params: { activityId, wbsId },
    });
    return res.data;
  },

  getNotationAccordionMatrix: async (workTreeNode: number) => {
    const res = await API.get(`/notation/accordion-matrix/${workTreeNode}`);
    return res.data;
  },

  getActivityBOM: async (
  projectId: number,
  wbsId: number,
  activityId: number
) => {
  const res = await API.get(
    `/thirdwbs/bom/${projectId}/${wbsId}/${activityId}`
  );

  return res.data;
},

getWbsBOM: async (
  projectId: number,
  wbsId: number
) => {
  const res = await API.get(
    `/thirdwbs/wbs-bom/${projectId}/${wbsId}`
  );

  return res.data;
},
};


export const SpecsAPI = {
  getByNode: async (
    projectId: number,
    scope: number,
    parentNo: number
  ) => {
    const res = await API.get(`/specs/${projectId}`, {
      params: { scope, parentNo },
    });

    return res.data;
  },

  // 🔹 Detail dropdown options
  getDetailOptions: async (componentGroup: number) => {
    const res = await API.get(
      `/specs/details/${componentGroup}`
    );

    return res.data;
  },

  // 🔹 Update selected detail
  updateDetail: async (
    specNo: number,
    detailNo: number
  ) => {
    const res = await API.post("/sql/update", {
      Table: "Specs",
      Key: "SpecNo",
      Data: {
        SpecNo: specNo,
        Detail: detailNo,
      },
    });

    return res.data;
  },
};

export default API;